import { useEffect, useState } from "react";
import { LINEAR_BASE_ROUTE } from "../../routes/linearRouteConstants";

const VALID_LINEAR_PATHS = [
    LINEAR_BASE_ROUTE
]

const useIsLinearPreRun = (): boolean | undefined => {
    const [isLinear, setIsLinear] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const pathname = window.location.pathname;
        const firstSegment = pathname.split("/").filter(Boolean)[0];
        setIsLinear(VALID_LINEAR_PATHS.includes(firstSegment));
    }, []);

    return isLinear;
};

export default useIsLinearPreRun;
